import React, { useEffect } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";

// @mui/material components
import { Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText } from "@mui/material";

// core components
import Button from "components/button/button";
import Loader from '../../configuration/components/loader';

// actions
import { deleteSector } from "actions/sector/delete";

function DeleteDialog(props) {
    const { sector, closeDialog, deleted, loading, isOpen } = props;

    const isSubSector = Boolean(sector && sector.parent !== null);

    useEffect(() => {
        if (deleted) {
            closeDialog();
        }
    }, [deleted]);

    return (
        <Dialog
            open={isOpen}
            onClose={closeDialog}
            maxWidth={'xs'}
            scroll={'body'}
        >
            <DialogTitle>
                <FormattedMessage
                    id={isSubSector ? "sector.delete.sub.title" : "sector.delete.title"}
                    values={{ sector: sector.name }}
                />
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <FormattedMessage id={"sector.delete.text"} />
                </DialogContentText>
            </DialogContent>
                <DialogActions>
                    <Button color={"info"} simple onClick={closeDialog} disabled={loading}>
                        <FormattedMessage id={"sector.delete.cancel"} />
                    </Button>
                    <Button
                        round
                        color={"danger"}
                        type="submit"
                        disabled={loading}
                        onClick={() => props.deleteSector(sector)}
                    >
                        <FormattedMessage id={"sector.delete.submit"} />
                        {loading && <Loader />}
                    </Button>
                </DialogActions>
        </Dialog>
    )
}

const mapStateToProps = state => {
    return {
        loading: state.sector.deleteSector.loading,
        deleted: state.sector.deleteSector.deleted,
    }
};

const mapDispatchToProps = dispatch => ({
    deleteSector: (item) => dispatch(deleteSector(item)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeleteDialog);
